import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LookupsService } from 'src/app/core/service/lookup.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
})
export class AdminLayoutComponent implements OnInit {
  toggleSide = false;
  menuLoading = true;
  isLoading: boolean = false;
  constructor(private _LookupsService: LookupsService, private router: Router) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this._LookupsService.show();
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this._LookupsService.hide();
      }
    });

    this._LookupsService.isLoading.subscribe(loading => {
      this.isLoading = loading;
    });

  }

  ngOnInit() {
  }
}
